<template>
    <div class="row pricing-table-one">
        <div class="col-md-6 col-xl-12 pricing-table wow move-up" v-for="(pricing, index) in pricingTable" :key="index">
            <div class="pricing-table__inner">
                <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
                    <span>Popular Choice</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
                    </div>
                    <h5 class="pricing-table__title">{{ pricing.title }}</h5>
                    <div class="pricing-table__price-wrap">
                        <h6 class="currency">$</h6>
                        <h6 class="price">{{ pricing.value }}</h6>
                        <h6 class="period">/{{ pricing.duration }}</h6>
                    </div>
                </div>
                <div class="pricing-table__body">
                    <ul class="pricing-table__list">
                        <li v-for="(list, index) in pricing.price" :key="index">{{ list }}</li>
                    </ul>
                </div>
                <div class="pricing-table__footer">
                    <a href="https://www.paypal.com/paypalme/redrisadsaluddigital" class="ht-btn ht-btn-default" :class="{'ht-btn--outline': pricing.active}">Aporta</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pricing',
        data (){
            return {
                pricingTable: [
                    {
                        thumb: require('../assets/img/pricing/aeroland-pricing-05-image-01.png'),
                        title: '',
                        value: '30',
                        duration: 'año',
                        alt: 'Pricing',
                        isPopular: false,
                        active: true,
                        price: ['Sabados del Conociemiento', 'Conferencia Anual', 'Networking con Miembros']
                    },
                ]
            }
        }
    }
</script>